<template>
    <div class="form">
        <!-- Car park types options -->
        <div class="form__section">
            <div class="form__title">Parktyp</div>
            <div class="form__fields">
                <div class="form__field-row">
                    <SmrChoiceGroup 
                        :values="data.categories" 
                        :options="categoriesOptions"
                        :tracking-data-category="'Parking'"
                        :min-amount="1"
                        :output-array="true"
                        @change="fieldChangeHandler($event, 'categories')"
                    />
                </div>
            </div>
        </div>
        
        <!-- price mode options -->
        <div class="form__section">
            <div class="form__title">Preis</div>
            <div class="form__fields">
                <div class="form__field-row">
                    <SmrChoiceGroup 
                        :values="data.priceMode" 
                        :options="priceModeOptions"
                        :output-array="true"
                        :single-choice="true"
                        @change="fieldChangeHandler($event, 'priceMode')"
                    />
                </div>
            </div>
        </div>
        
        <!-- Operators options -->
        <div class="form__section">
            <div class="form__title">Betreiber</div>
            <div class="form__fields">
                <div class="form__field-row">
                    <SmrSelect 
                        :options="operatorOptions" 
                        :value="data.operator" 
                        :multiple="true" 
                        placeholder="Filtern Sie die Ergebnisse nach bestimmten Betreibern" 
                        @change="fieldChangeHandler($event, 'operator')"
                    />
                </div>
            </div>
        </div>
    
        <!-- Other options -->
        <div class="form__section">
            <div class="form__title">Weitere Filteroptionen</div>
            <div class="form__fields">
                <div class="form__field-row">
                    <SmrChoiceGroup 
                        :values="data.other" 
                        :options="otherOptions"
                        @change="fieldChangeHandler($event, 'other')"
                    />
                </div>
            </div>
        </div>


    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import settingsTabBlueprint from '@/mixins/settings-tab-blueprint';
import { getPoiConfig } from '@/utils/poi-data/poi-config'
import SmrSelect from '@/components/form/SmrSelect.vue'
import SmrChoiceGroup from '@/components/form/SmrChoiceGroup.vue'
export default {
    components: {
        SmrSelect,
        SmrChoiceGroup,
    },
    mixins: [
        settingsTabBlueprint
    ],
    data() {
        return {
            data: {},
            categoriesOptions: getPoiConfig(this.optionsId).categories,
            priceModeOptions: [
                {value: 'PER_HOUR', label: 'Stündlicher Preis', },
                {value: 'PER_MONTH', label: 'Monatlicher Preis', },
            ],
            operatorOptions: getPoiConfig(this.optionsId).operators
        }
    },
    computed: {
        ...mapGetters(['user']),
        otherOptions() {
            return [
                {value: 'openNextHour', label: 'In der nächsten Stunde geöffnet' },
                {value: 'openAllDay', label: '24 h geöffnet' },
                {value: 'oeamtcPartner', label: 'Nur Vorteilspartner' },
                {value: 'accessible', label: 'Nur Barrierefrei' },
                {value: 'favouritesOnly', label: 'Nur Favoriten', disabled: this.user ? false : true},
            ]
        }
    }

}
</script>
